import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import type { Contract } from "@features/contracts/api";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import type { ColumnsType, ColumnType } from "antd/es/table";
import dayjs from "dayjs";

export const contractDataColumns: ColumnsType<Contract> = [
  { title: "ИНН", dataIndex: "inn", width: 140 },
  { title: "Номер договора", dataIndex: "contract_number", width: 180 },
  { title: "Компания", dataIndex: "company_name", ellipsis: true },
  {
    title: "Счётчики",
    dataIndex: "meters",
    width: 90,
    render: (_v, record) => record.meters?.length ?? 0,
  },
  {
    title: "Обновлён",
    dataIndex: "updated_at",
    width: 140,
    render: (v?: string) => (v ? dayjs(v).format("DD.MM.YYYY HH:mm") : "—"),
  },
];

export const contractActionColumn = (
  onEdit: (record: Contract) => void,
  onDelete: (id: string) => void,
): ColumnType<Contract> => ({
  title: "",
  width: 80,
  render: (_: unknown, record: Contract) => (
    <Space>
      <Tooltip title="Редактировать">
        <Button size="small" type="text" icon={<EditOutlined />} onClick={() => onEdit(record)} />
      </Tooltip>
      <Popconfirm title="Удалить договор?" onConfirm={() => onDelete(record.id)}>
        <Tooltip title="Удалить">
          <Button size="small" type="text" danger icon={<DeleteOutlined />} />
        </Tooltip>
      </Popconfirm>
    </Space>
  ),
});
